import { Button, Modal } from 'antd';

type Country = 'UK' | 'IE';

type Props = {
  isOpen: boolean;
  country: Country;
  onYes: () => void;
  onNo: () => void;
};

const COPY: Record<Country, { title: string; message: string }> = {
  UK: {
    title: 'Submit FPS',
    message: 'Do you now wish to submit FPS?',
  },
  IE: {
    title: 'Submit PSR',
    message: 'Do you now wish to submit PSR?',
  },
};

const SubmitFpsPsrPopup: React.FC<Props> = ({
  isOpen,
  country,
  onYes,
  onNo,
}) => {
  const copy = COPY[country];

  return (
    <Modal
      open={isOpen}
      onCancel={onNo}
      title={copy.title}
      centered
      width={420}
      zIndex={1100}
      footer={[
        <Button key="no" onClick={onNo}>
          No
        </Button>,
        <Button key="yes" type="primary" onClick={onYes}>
          Yes
        </Button>,
      ]}
    >
      <div style={{ padding: '12px 0', fontSize: 14 }}>{copy.message}</div>
    </Modal>
  );
};

export default SubmitFpsPsrPopup;
